// extracted by mini-css-extract-plugin
export var modal_results = "styles-module--modal_results--1483f";
export var no_results = "styles-module--no_results--2cb9a";
export var result = "styles-module--result--aeebf";
export var results_list = "styles-module--results_list--98d1f";